<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title" :title1="title1" />
        <!-- /add -->
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-6 col-sm-6 col-12">
                <div class="form-group">
                  <label>Category Name</label>
                  <b-form-input type="text" v-model="form.categoryname" ref='firstInput' @keypress.enter="submitForm()"/>
                </div>
              </div>
              <div class="col-lg-6 col-sm-6 col-12">
                <div class="form-group">
                  <label>Category Code</label>
                  <b-form-input type="text"  v-model="form.categorycode" @keypress.enter="submitForm()"/>
                </div>
              </div>

              <div class="col-lg-12">
                <div class="form-group">
                  <label>Description</label>
                  <b-form-textarea
                    id="textarea"
                    v-model="form.description"
                    rows="3"
                    max-rows="6"
                    @keypress.enter="submitForm()"
                  ></b-form-textarea>
                </div>
              </div>

              <div class="col-lg-12">
                <a v-on:click="postData()" class="btn btn-submit me-2">Submit</a>
                <router-link to="categorylist" class="btn btn-cancel">Cancel</router-link>
              </div>
            </div>
          </div>
        </div>
        <!-- /add -->
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.post['Content-Type'] ='application/json;charset=utf-8';
export default {
  data() {
    return {
      form: {
        categoryname: '',
        categorycode: '',
        description: '',
      },
      title: "Item Add Category",
      title1: "Create new item category",
    };
  },
  methods: {
    async postData() {
      if (!this.form.categoryname) {
        Swal.fire("Please enter the category name");
        return;
      }
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: "Do you really want to submit the form?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, submit it!'
      });

      if (result.isConfirmed) {
      axios
      .post('/v1/category', this.form)
      .then(response => {
        //this.res = "Status " + response.status + ". Category created";
        Swal.fire("Category created successfully");
        this.$router.push({ path: '/categorylist' });
      })
      .catch(error => {
        console.log(error)
        Swal.fire(error.response.data.detail);
      });
      }
    },
    submitForm() {
      this.postData();
    }
  },
  mounted(){
    this.$refs.firstInput.focus();
  },
  name: "addcategory",
};
</script>
